<form autocomplete="off" [formGroup]="emailForm">
  <div class="flex justify-between items-baseline">
    <h4 class="user-profile-heading">Emails</h4>
    <button mat-icon-button matTooltip="Add Entry" [matMenuTriggerFor]="emailMenu">
      <mat-icon class="plus">add</mat-icon>
    </button>
  </div>

  <div class="flex">
    <mat-menu #emailMenu="matMenu">
      @for (content of email_content; track content) {
        @if (!content.isSelected) {
          <button (click)="addEmailType(content)" mat-menu-item>{{content.name}}</button>
        }
      }
    </mat-menu>
  </div>

  <div formArrayName="emails">
    @for (email of emailListArr.controls; track email; let i = $index) {
      <ng-container [formGroupName]="i">
        <div class="flex w-full gap-3 place-items-center">
          <mat-form-field class="w-[25%]">
            <mat-label>Type</mat-label>
            <mat-select disableOptionCentering matNativeControl formControlName="email_type" [disabled]="email?.value?.email_class == 'true'" [ngClass]="{'line-through': email?.value?.email_class == 'true'}">
              @for (content of email_content; track content) {
                <mat-option value="{{content.name}}">{{content.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="w-[65%]">
            <mat-label>Email</mat-label>
            <input [class]="email?.value?.email_class == 'true' ? 'not-allowed' : ''" [readonly]="email?.value?.email_class == 'true'"  [appInputMaxLength] matInput autocomplete="off" formControlName="email" [ngClass]="{'line-through': email?.value?.email_class == 'true'}" appDisableAutofill>
            @if (email?.get('email')?.errors && submitted) {
              <mat-error>
                Please enter correct email
              </mat-error>
            }
          </mat-form-field>
          @if (email?.value?.email_class == '') {
            <button mat-icon-button class="close" title="Undo" (click)="clearEmail(email.value,i)"><mat-icon>close</mat-icon></button>
          }
          @if (email?.value?.email_class == 'true') {
            <button mat-icon-button (click)="refreshEmail(email.value,i)"><mat-icon>replay</mat-icon></button>
          }
          @if (type!='admin') {
            <mat-checkbox matTooltip="Default Email" [matTooltipDisabled]="email?.value?.isSelected==false" (change)="emailCheckBoxvalue($event,email.value,i)" [checked]="email?.value?.isSelected==true || type == 'plan' || type=='add-user'"></mat-checkbox>
          }
        </div>
      </ng-container>
    }
  </div>
</form>
